import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function WeddingEcosystem() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-sandstone relative" id="partner" data-id="element-193" data-mp="3q8pnlu0csmm7">
      <JaliDivider className="absolute top-0 left-0" data-id="element-194" data-mp="3m8p8061iq5dk" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-195" data-mp="3m7xer1ve8jqg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-196" data-mp="3ha4a4d9qnxsa">
          <span className="text-saffron tracking-widest uppercase text-sm font-medium mb-4 block" data-id="element-197" data-mp="33bo1ggsbfx7i">
            {t('weddingEcosystem.eyebrow')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-8" data-id="element-198" data-mp="11j9nfssw7cwd">
            {t('weddingEcosystem.title')}
          </h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-10" data-id="element-199" data-mp="2ntjgpqivy9g7">
            <div className="rounded-sm overflow-hidden shadow-xl border border-gold/20 mb-6" data-id="element-200" data-mp="36k13leh1eatn">
              <img src="https://cdn.magicpatterns.com/uploads/6ajCEhJ7gMrag7RfAVytuR/Gemini_Generated_Image_q0e33oq0e33oq0e3.png" alt="Interior of the Darbar Sahib" className="w-full h-auto max-h-[500px] object-cover" data-id="element-201" data-mp="3bj5ce401u6jg" />
            </div>
            <div className="bg-marble p-6 rounded-sm border border-gold/10 text-center shadow-sm" data-id="element-202" data-mp="3pepke4e8p4c3">
              <p className="text-navy/80 text-base md:text-lg leading-relaxed italic" data-id="element-203" data-mp="3u9n548kvt24t">
                {t('weddingEcosystem.imageCaption')}
              </p>
            </div>
          </motion.div>

          <div className="bg-marble p-8 md:p-12 rounded-sm border border-gold/20 shadow-sm mb-10" data-id="element-204" data-mp="3uf8pqh7l0jj">
            <p className="text-navy/80 text-lg leading-relaxed mb-8" data-id="element-205" data-mp="3v4xg5o2gilwr">
              {t('weddingEcosystem.description')}
            </p>
            <p className="text-navy/60 italic mb-8" data-id="element-206" data-mp="3l56lnmdwc6wo">
              {t('weddingEcosystem.plannerNote')}
            </p>

            <a href="https://form.typeform.com/to/BGQF1C1p" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-navy hover:text-ivory transition-colors duration-300" data-id="element-207" data-mp="3gcvlqjj5ol44">
              {t('weddingEcosystem.cta')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}